var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('c-budg-head',{ref:"budgetHeader",attrs:{"specificProp":_vm.specificProp,"form":_vm.form,"defaultProps":_vm.defaultProps,"developType":0},on:{"chgData":_vm.chgData,"testSpecific":_vm.test}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }